// r10x-demo: PLACEHOLDER loopback API URL (reach via SSH tunnel). Replace with the real demo API domain once provided.
export const environment = {
  production: false,
  encryptSecretKey: 'r10x-dashboard-encrypt-key-dev',
  apiUrl: 'https://api.demo.retail10x.com/', // development branch
  //apiUrl: 'https://r10x-api-gcp-file-upload-711579377765.us-east4.run.app/', // gcp-file-upload branch
  //aws_key: 'AKIAYZZGSS3IOXI2IVPV', // DELETED ON 27-05-2025
  //aws_secret: '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', // DELETED ON 27-05-2025
  cloud_storage_bucket: 'r10x-files',
  cloud_storage_folder_prefix: 'dev',
  cloud_storage_folder_coupons: 'coupons',
  cloud_storage_folder_tcb_coupons: 'tcb-coupons',
  cloud_storage_folder_circulars: 'circulars',
  cloud_storage_folder_sms_campaigns: 'sms_campaigns',
  cloud_storage_folder_push_notification_campaigns: 'push_notification_campaigns',
  /*aws_key: 'AKIAYZZGSS3IFGWH2XT4',
  aws_secret: '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',
  s3_region: 'us-west-1',
  s3_bucket: 'r10xai-web-dashboard-assets-dev',
  s3_folder_coupons: 'coupons',
  s3_folder_tcb_coupons: 'tcb-coupons',
  s3_folder_circulars: 'circulars',
  s3_folder_sms_campaigns: 'sms_campaigns',
  s3_folder_push_notification_campaigns: 'push_notification_campaigns',*/
  apiErrorMessage: 'Error from server!',
  report_data_color: '#8C419C',
  compare_data_color: '#5FA1D3',
  default_chart_color: '#0DCAF0',
  default_chart_area_color: 'rgba(13,202,240,0.1)'
};
